
const enumModules = {}
const enumMaps = {}

const req = context => context.keys().map(context)
const enumFiles = req(require.context('@/enums', true, /\.js$/))

enumFiles.forEach(file => {
  const maps = {}
  for (const key in file) {
    if (file[key] instanceof Array) {
      const map = {}
      for (const mapItem of file[key]) {
        map[mapItem['value']] = mapItem
      }
      maps[key] = map
    } else {
      if (enumModules[key]) {
        console.warning('枚举重复：' + key)
      }
      enumModules[key] = file[key]
    }
  }
  Object.assign(enumMaps, maps)
})

export default { enumModules, enumMaps }
